import { render } from "./setup.vue?vue&type=template&id=437e0c68&scoped=true"
import script from "./setup.vue?vue&type=script&lang=js"
export * from "./setup.vue?vue&type=script&lang=js"

import "./setup.vue?vue&type=style&index=0&id=437e0c68&lang=scss&scoped=true"
import "./setup.vue?vue&type=style&index=1&id=437e0c68&lang=scss"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-437e0c68"]])

export default __exports__